const APPLICATION_DECLINED_SUCCESS = 'APPLICATION_DECLINED_SUCCESS';
const APPLICATION_DECLINED_FAILURE = 'APPLICATION_DECLINED_FAILURE';

export const addAction = {
  applicationDeclinedSuccess: (ctx = {}) => window.DD_RUM?.addAction(APPLICATION_DECLINED_SUCCESS, ctx),
  applicationDeclinedFailure: (ctx = {}) => window.DD_RUM?.addAction(APPLICATION_DECLINED_FAILURE, ctx),
};
